import React from 'react';
import { Zap, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export function GenerateDialog({ 
  isOpen, 
  onOpenChange, 
  templateName,
  generating,
  generateForm,
  setGenerateForm,
  onGenerate,
  activeTemplatesCount,
  isBulk = false
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      {isBulk && (
        <DialogTrigger asChild>
          <Button variant="outline" disabled={activeTemplatesCount === 0}>
            <Zap className="w-4 h-4 mr-2" />
            Generate All
          </Button>
        </DialogTrigger>
      )}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isBulk ? 'Generate Visits from All Templates' : 'Generate Visits'}</DialogTitle>
          <DialogDescription>
            {isBulk 
              ? 'Create visits from all active templates for a date range'
              : `Create visits from "${templateName}"`
            }
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Start Date</Label>
              <Input
                type="date"
                value={generateForm.start_date}
                onChange={(e) => setGenerateForm(prev => ({ ...prev, start_date: e.target.value }))}
              />
            </div>
            <div className="space-y-2">
              <Label>End Date</Label>
              <Input
                type="date"
                value={generateForm.end_date}
                onChange={(e) => setGenerateForm(prev => ({ ...prev, end_date: e.target.value }))}
              />
            </div>
          </div>
          {isBulk && (
            <p className="text-sm text-slate-500">
              Active templates: {activeTemplatesCount}
            </p>
          )}
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button onClick={onGenerate} disabled={generating} className="bg-teal-600 hover:bg-teal-700">
              {generating ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Zap className="w-4 h-4 mr-2" />}
              {isBulk ? 'Generate Visits' : 'Generate'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
